<template>
  <form action="">
    <b-loading v-model="isLoading"></b-loading>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">支払い方法の登録</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <VCreditCard
          @change="creditInfoChanged"
          :noCard="false"
          :yearDigits="4"
        />
      </section>
      <footer class="modal-card-foot">
        <b-button label="Close" @click="$emit('close')" />
        <b-button label="Submit" @click="submit" type="is-primary" />
      </footer>
    </div>
  </form>
</template>

<script>
import VCreditCard from 'v-credit-card';

export default {
  name: 'PaymentMethodFormModal',
  data() {
    return {
      creditCardInfo: {},
      isLoading: false
    };
  },
  created() {},
  components: {
    VCreditCard
  },
  methods: {
    creditInfoChanged(values) {
      this.creditCardInfo = values;
    },
    async submit() {
      try {
        this.isLoading = true;
        const payload = {
          userId: this.$store.state.auth.uid,
          number: Number(this.creditCardInfo['cardNumber'].replaceAll(' ', '')),
          cvc: Number(this.creditCardInfo['security']),
          expMonth: Number(this.creditCardInfo['expiration'].split('/')[0]),
          expYear: Number(this.creditCardInfo['expiration'].split('/')[1])
        };
        await this.$store.dispatch('payment/addPaymentMethod', payload);
      } catch (err) {
        console.error(err);
      }
      this.isLoading = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss"></style>
